export const registerRoute = (integrationRoutes, routeToRegister) => {
  const routeGroup = integrationRoutes.find(route =>
    route.children?.some(
      child => child.name === 'settings_applications_integration'
    )
  );

  if (
    !routeGroup ||
    routeGroup.children.some(child => child.name === routeToRegister.name)
  ) {
    return false;
  }

  routeGroup.children.unshift(routeToRegister);
  return true;
};

export const registerDashboardRoute = (dashboardRoutes, routeToRegister) => {
  const dashboardRoute = dashboardRoutes.find(route => route.children);

  if (
    !dashboardRoute ||
    dashboardRoute.children.some(child => child.name === routeToRegister.name)
  ) {
    return false;
  }

  dashboardRoute.children.unshift(routeToRegister);
  return true;
};
